/* unplugin-vue-components disabled */import { render } from "./files-upload.vue?vue&type=template&id=0f31da72&scoped=true"
import script from "./files-upload.vue?vue&type=script&lang=js"
export * from "./files-upload.vue?vue&type=script&lang=js"

import "./files-upload.vue?vue&type=style&index=0&id=0f31da72&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f31da72"],['__file',"src/controls/files-upload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f31da72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f31da72', __exports__)) {
    api.reload('0f31da72', __exports__)
  }
  
  module.hot.accept("./files-upload.vue?vue&type=template&id=0f31da72&scoped=true", () => {
    api.rerender('0f31da72', render)
  })

}


export default __exports__